<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li>
              <router-link to="/closing_entries" class="">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
            </li>
            <li>
              <h3>{{ $t("accounting.label.createclosure") }}</h3>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("accounting.label.entity")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.entity')"
              >
                <v-select
                  v-if="OfficesList"
                  label="name"
                  v-model="entity"
                  :options="OfficesList"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("accounting.label.closingdate")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="closing date"
                >
                  <datepicker
                    :placeholder="$t('placeholder.label.SelectOne')"
                    v-model="closingDate"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.entity')"
              >
              <vs-input
                :label="$t('accounting.label.comments')"
                class="w-full mb-2 font-semibold"
                v-model="comments"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="haldleSubmit"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      closingDate: moment().format("DD MMMM yyyy"),
      entity: "",
      comments: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
    Datepicker,
  },

  computed: {
    ...mapState({
      OfficesList: (state) => state.accounting.officesList,
    }),
  },
  methods: {
    async getOfficeList() {
      try {
        this.$store.dispatch("accounting/getOfficesListAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async haldleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        officeId: this.entity,
        closingDate: this.closingDate,
        comments: this.comments,
        dateFormat: "dd MMMM yyyy",
        locale: "en",
      };
      try {
        await this.$store.dispatch("accounting/createClosureAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Closure Created Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push("/closing_entries");
      } catch (error) {
        const errorMessage = String(error.httpStatusCode).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.closingDate = moment().format("DD MMMM yyyy");
      this.entity = "";
      this.comments = "";
    },
  },
  mounted() {
    this.getOfficeList();
  },
};
</script>
<style>
.section-title {
  font-size: 1.1rem;
  display: inline-flex;
  align-items: center;
  margin-right: 1rem;
}
.flex-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.radio-group {
  display: flex;
  align-items: center;
}

.radio-option {
  display: flex;
  align-items: center;
}
</style>
